var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntegrationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3334 3.45319L13.9884 -0.000976562H7.33342C6.67037 -0.000976562 6.03449 0.262415 5.56565 0.731256C5.09681 1.2001 4.83342 1.83598 4.83342 2.49902V3.33236H3.16675C2.50371 3.33236 1.86782 3.59575 1.39898 4.06459C0.93014 4.53343 0.666748 5.16932 0.666748 5.83236V19.999H14.0001V15.8324H17.3334V3.45319ZM12.3334 18.3324H2.33341V5.83236C2.33341 5.61134 2.42121 5.39938 2.57749 5.2431C2.73377 5.08682 2.94573 4.99902 3.16675 4.99902H4.83342V15.8324H12.3334V18.3324ZM6.50008 14.1657V2.49902C6.50008 2.27801 6.58788 2.06605 6.74416 1.90977C6.90044 1.75349 7.1124 1.66569 7.33342 1.66569H12.3334V4.99902H15.6667V14.1657H6.50008Z",
    fill: "#ADB5BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationIcon);
export default __webpack_public_path__ + "static/media/IntegrationIcon.08febb539edd7685a6f57f46170f8b9e.svg";
export { ForwardRef as ReactComponent };